import React from 'react'


const Welcome = () => {
    return (
        <div className="fatherWelcome">
            <main className="childWelcome"></main>
        </div>
    )
}

export default Welcome
